/**
 * Device Type display for the org device list — identical rule to
 * processDeviceData.deviceName in the user dashboard:
 *   compassInfo?.hardware_version || 'N/A'
 * (trim so whitespace-only counts as missing).
 */
export function formatDeviceTypeLabel(
  hardwareVersion: string | null | undefined,
): string {
  const name = (hardwareVersion ?? '').trim();
  return name.length > 0 ? name : 'N/A';
}
